import { styled } from '@mui/system'
import React from 'react'

import { WTPayload } from '@f-fertighaus/applications/Next/types/WTPayload'
import { webtrack } from '@f-fertighaus/applications/Next/utils/webtrack'

interface LinkWrapperProps extends React.ComponentPropsWithoutRef<'a'> {
  url: string
  children: React.ReactNode
}

const StyledAnchor = styled('a')`
  color: inherit;
  text-decoration: none;

  // this reverts the global CSS outline style from 00_helpers.css as it breaks specifically in HDP swiper carousels
  &:focus-visible {
    outline: revert;
  }
`

interface LinkWrapperWithWTProps extends LinkWrapperProps {
  wtPayload: WTPayload
}

export const LinkWrapperWithWT = ({
  url,
  children,
  wtPayload,
  ...rest
}: LinkWrapperWithWTProps) => (
  <StyledAnchor href={url} onClick={() => webtrack(wtPayload)} {...rest}>
    {children}
  </StyledAnchor>
)
